import React from "react";
import {
  EffortlessWrapper,
  EffortlessContainer,
  EffortlessCards,
  Card,
  CardContent,
  EffortlessHead,
  CardHead
} from "./style";

const data = [
  {
    title: "Generate",
    desc: "Create art, photographs and illustrations in any style you can imagine",
    img: "/assets/efortless/generate.png",
    soon: false,
    delay: 300
  },
  {
    title: "Edit",
    desc: "Work across multiple images at once with our improved canvas",
    img: "/assets/efortless/edit.png",
    soon: true,
    delay: 600
  },
  {
    title: "Add",
    desc: "Replace, add and edit elements within your images with inpainting and outpainting",
    img: "/assets/efortless/add.png",
    soon: true,
    delay: 900
  },
  {
    title: "Models",
    desc: "Get early access to our latest and greatest StableDiffusion model",
    img: "/assets/efortless/model.png",
    soon: true,
    delay: 1200
  },
];

const Effortless = () => {
  return (
    <EffortlessWrapper>
      <EffortlessContainer>
        <EffortlessHead>
          <h1 data-aos="fade-down">Effortless image generation for creators with Stellar</h1>
          <p data-aos="fade-down">DreamStudio by Stellar.ai</p>
        </EffortlessHead>
        <EffortlessCards>
          {data.map((i, k) => (
            <Card key={k} data-aos="fade-up" data-aos-delay={`${i.delay}`}>
              <img src={i.img} alt="" />
              <CardContent>
                <CardHead>
                  <h4>{i.title}</h4>
                  {i.soon ? <span>soon</span> : ""}
                </CardHead>
                <span>{i.desc}</span>
              </CardContent>
            </Card>
          ))}
        </EffortlessCards>
      </EffortlessContainer>
    </EffortlessWrapper>
  );
};

export default Effortless;
